import { serverURL } from '../config';

async function createOrgDoc(req, sender) {
  const createOrgDocRes = await fetch(`${serverURL}/api/orgDoc`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(req.payload),
  });
  const createOrgDocData = createOrgDocRes.json();
  return createOrgDocData;
}

async function updateOrgDoc(req, sender) {
  const updateOrgDocRes = await fetch(`${serverURL}/api/orgDoc`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(req.payload),
  });
  const updateOrgDocData = updateOrgDocRes.json();
  return updateOrgDocData;
}

async function deleteOrgDoc(req, sender) {
  const deleteOrgDocRes = await fetch(`${serverURL}/api/orgDoc`, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(req.payload),
  });
  const deleteOrgDocData = deleteOrgDocRes.json();
  return deleteOrgDocData;
}

export { createOrgDoc, updateOrgDoc, deleteOrgDoc };
